import { Link } from "react-router-dom"

import { Box, Divider, Flex, Typography } from "components/common/index"
import {
  SectionText,
  SectionTitle,
  VibeButton,
  VibeForm,
  VibeImageBlock,
} from "jewlr/main/vibe/index"

const NWVibe = () => {
  return (
    <Box contain px={1} py={3}>
      <Box>
        <Box textAlign="center">
          <Typography as="h3" fontSize={26} fontWeight="normal">
            Welcome to Jewlr!
          </Typography>
          <Typography fontSize={16} mb={2}>
            You’re married! Welcome to the next chapter of your love story! Your
            life together is just beginning, and we want to help you make every
            moment sparkle. Register your email address below, and you’ll be
            entered to win a $150 gift card! And just for signing up, we’ll give
            you an extra 20% off your next purchase.
          </Typography>
        </Box>

        <VibeForm mailList="newlywed_vibe_20181009" promoCode="JEWLRVIBE" />
      </Box>

      <Divider bg="grey20" my={3} />

      <Flex alignItems="center" flexDirection={{ _: "column", tablet: "row" }}>
        <VibeImageBlock
          maxWidth={{ _: "100%", tablet: "80%" }}
          paths={{
            desktop: [
              require("images/vibe/bands/desktop.jpg"),
              require("images/vibe/bands/desktop_2x.jpg"),
            ],
            mobile: [
              require("images/vibe/bands/mobile.jpg"),
              require("images/vibe/bands/mobile.jpg"),
            ],
          }}
        />
        <Box flex="1">
          <SectionTitle>ANNIVERSARY BANDS</SectionTitle>
          <SectionText fontSize={16} mb={2}>
            Relive the magic of your wedding day with a commemorative
            anniversary band. Customize it to perfectly compliment your wedding
            bands with your choice of gemstones and precious metal. Add an
            engraved message that captures your special bond and your promise of
            forever. Browse our anniversary collection today!
          </SectionText>
          <Flex justifyContent="space-between">
            <VibeButton as={Link} data-lc="nw-vibe" to="/bands-for-her">
              SHOP BANDS FOR HER
            </VibeButton>
          </Flex>
        </Box>
      </Flex>

      <Divider bg="grey20" my={3} />

      <Flex alignItems="center" flexDirection={{ _: "column", tablet: "row" }}>
        <VibeImageBlock
          display={{ _: "block", tablet: "none" }}
          paths={{
            desktop: [
              require("images/vibe/necklace_desktop.jpg"),
              require("images/vibe/necklace_desktop_2x.jpg"),
            ],
            mobile: [
              require("images/vibe/necklace_mobile.jpg"),
              require("images/vibe/necklace_mobile_2x.jpg"),
            ],
          }}
        />
        <Box flex="1" textAlign={{ tablet: "right" }}>
          <SectionTitle>BIRTHDAY GIFTS</SectionTitle>
          <SectionText>
            Make birthdays sparkle with unique gifts! From name necklaces to
            bracelets to rings, we have everything you need to create a gift
            like no other. Celebrate
          </SectionText>
          <Flex justifyContent={{ tablet: "flex-end" }}>
            <VibeButton
              as={Link}
              data-lc="nw-vibe"
              to="/name-jewelry-collection"
            >
              SHOP NOW
            </VibeButton>
          </Flex>
        </Box>
        <VibeImageBlock
          display={{ _: "none", tablet: "block" }}
          paths={{
            desktop: [
              require("images/vibe/necklace_desktop.jpg"),
              require("images/vibe/necklace_desktop_2x.jpg"),
            ],
            mobile: [
              require("images/vibe/necklace_mobile.jpg"),
              require("images/vibe/necklace_mobile_2x.jpg"),
            ],
          }}
        />
      </Flex>

      <Divider bg="grey20" my={3} />

      <Flex alignItems="center" flexDirection={{ _: "column", tablet: "row" }}>
        <VibeImageBlock
          paths={{
            desktop: [
              require("images/vibe/pendant/desktop.jpg"),
              require("images/vibe/pendant/desktop_2x.jpg"),
            ],
            mobile: [
              require("images/vibe/pendant/mobile.jpg"),
              require("images/vibe/pendant/mobile.jpg"),
            ],
          }}
        />
        <Box flex="1">
          <SectionTitle>SPECIAL OCCASION</SectionTitle>
          <SectionText>
            Whether you’re starting a family, commemorating a milestone, or
            exchanging tokens of love “just because,” life’s special occasions
            call for special gifts.
          </SectionText>
          <Flex>
            <VibeButton as={Link} data-lc="nw-vibe" to="/pendants">
              SHOP NOW
            </VibeButton>
          </Flex>
        </Box>
      </Flex>

      <Divider bg="grey20" my={3} />

      <Flex alignItems="center" flexDirection={{ _: "column", tablet: "row" }}>
        <VibeImageBlock
          display={{ _: "block", tablet: "none" }}
          paths={{
            desktop: [
              require("images/vibe/bracelet/desktop.jpg"),
              require("images/vibe/bracelet/desktop_2x.jpg"),
            ],
            mobile: [
              require("images/vibe/bracelet/mobile.jpg"),
              require("images/vibe/bracelet/mobile.jpg"),
            ],
          }}
        />
        <Box flex="1" textAlign={{ tablet: "right" }}>
          <SectionTitle>SOMETHING FOR EVERYONE</SectionTitle>
          <SectionText fontSize={16} mb={2}>
            With our wide selection of jewelry, there’s something for everyone
            and every moment. Add sentimental value with birthstones and
            engravings to make each piece truly one-of-a-kind. Find the perfect
            gift today!
          </SectionText>
          <Flex justifyContent={{ tablet: "flex-end" }}>
            <VibeButton as={Link} data-lc="nw-vibe" to="/heart-jewelry">
              SHOP THE COLLECTION
            </VibeButton>
          </Flex>
        </Box>
        <VibeImageBlock
          display={{ _: "none", tablet: "block" }}
          maxWidth={{ _: "100%", tablet: "80%" }}
          ml="50px"
          paths={{
            desktop: [
              require("images/vibe/bracelet/desktop.jpg"),
              require("images/vibe/bracelet/desktop_2x.jpg"),
            ],
            mobile: [
              require("images/vibe/bracelet/mobile.jpg"),
              require("images/vibe/bracelet/mobile.jpg"),
            ],
          }}
        />
      </Flex>
    </Box>
  )
}

export default NWVibe
